import { useEffect, useState } from 'react'
import useSWR from 'swr'

import { AuthMethods } from './AuthMethods'
import type { MeResponse } from '../lib/auth-client'
import { fetcher } from '../lib/swr'

const DISMISS_KEY = 'menu.claimBannerDismissed'

/** Soft prompt after enough activity; email/Google always available. */
export function ClaimBanner({ me }: { me: MeResponse }) {
  const plans = useSWR<unknown[]>('/api/plans?view=home', fetcher)
  const [open, setOpen] = useState(false)
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1'
    } catch {
      return false
    }
  })

  const planCount = plans.data?.length ?? 0
  const thresholdMet = planCount >= 2

  useEffect(() => {
    if (!dismissed && thresholdMet) setOpen(true)
  }, [dismissed, thresholdMet])

  if (!me.user?.isAnonymous) return null

  function dismiss() {
    setOpen(false)
    setDismissed(true)
    try {
      localStorage.setItem(DISMISS_KEY, '1')
    } catch {
      /* ignore */
    }
  }

  return (
    <>
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="fixed top-3 right-3 z-40 rounded-full bg-green-950/90 text-white text-xs px-3 py-1.5 shadow pointer-fine:top-4 pointer-fine:right-4"
        >
          Bewaar account
        </button>
      )}

      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-black/40">
          <div className="w-full max-w-md bg-green-50 text-green-950 rounded-2xl p-5 space-y-3 shadow-xl">
            <div className="flex justify-between gap-2 items-start">
              <div>
                <h2 className="font-semibold text-lg">Bewaar je account</h2>
                <p className="text-sm text-green-800/80 mt-1">
                  {thresholdMet
                    ? 'Je hebt al plannen staan. Koppel e-mail of Google zodat je later terug kunt.'
                    : 'Koppel e-mail of Google wanneer je wilt — niet verplicht om verder te plannen.'}
                </p>
              </div>
              <button
                type="button"
                onClick={dismiss}
                className="text-sm underline"
              >
                Later
              </button>
            </div>
            <AuthMethods />
          </div>
        </div>
      )}
    </>
  )
}
